// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/solid/ellipsis-vertical.svg. Do not edit.

import type { Glyph } from '../../types'

export const glyph: Glyph = {
  name: 'ellipsis-vertical',
  version: 'solid',
  paths: [
    {
      d: 'M12 3.6a1.8 1.8 0 1 1 0 3.6 1.8 1.8 0 0 1 0-3.6m0 6.6a1.8 1.8 0 1 1 0 3.6 1.8 1.8 0 0 1 0-3.6m1.8 8.4a1.8 1.8 0 1 0-3.6 0 1.8 1.8 0 0 0 3.6 0',
    },
  ],
}
